var React = require('react');

function IconMenu (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M24,3c0-0.6-0.4-1-1-1H1C0.4,2,0,2.4,0,3v2c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1V3z","fill":"#FFFFFF","key":0}),React.createElement("path",{"d":"M24,11c0-0.6-0.4-1-1-1H1c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1V11z","fill":"#FFFFFF","key":1}),React.createElement("path",{"d":"M24,19c0-0.6-0.4-1-1-1H1c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1V19z","fill":"#FFFFFF","key":2})]));
}

IconMenu.defaultProps = {"version":"1.1","viewBox":"0 0 24 24","enableBackground":"new 0 0 24 24","width":"512px","height":"512px"};

module.exports = IconMenu;

IconMenu.default = IconMenu;
